// import React, { useState, useRef, useEffect, useContext } from 'react';
// import { DndProvider, useDrag, useDrop } from 'react-dnd';
// import { HTML5Backend } from 'react-dnd-html5-backend';
// import ReactToPrint from "react-to-print";
// // import print from "./images/icons/icons8-print-100.png";
// // import ss from './images/login/ss_Logo.png';
// // import close from './images/Inventory/close (1).png';
// // import { DBContext } from './DBContext';
// import { ToastContainer, toast } from 'react-toastify';
// import { useLocation, useNavigate } from 'react-router-dom';
// import io from 'socket.io-client';
// import { DBContext } from '../DBContext'
// import { DineContext } from '../DineContext'
// // import { DBContext } from './DBContext'
// import print from '../assets/assets/images/print.png'
// import close from '../assets/assets/images/close.png'
// import Remove from "../images/icons/remove.png" //remove.png
// // Draggable Item Component
// const DraggableItem = ({ item, index, moveItem, type = "product" }) => {
// 	const [{ isDragging }, drag] = useDrag({
// 		type: 'PRINT_ITEM',
// 		item: { index, type },
// 		collect: (monitor) => ({
// 			isDragging: monitor.isDragging(),
// 		}),
// 	});

// 	const [, drop] = useDrop({
// 		accept: 'PRINT_ITEM',
// 		hover: (draggedItem) => {
// 			if (draggedItem.index !== index) {
// 				moveItem(draggedItem.index, index, draggedItem.type);
// 				draggedItem.index = index;
// 			}
// 		},
// 	});

// 	const opacity = isDragging ? 0.4 : 1;

// 	if (type === "product") {
// 		const hasVariant = item.variantName || null;
// 		return (
// 			<div ref={(node) => drag(drop(node))} style={{ opacity }} className='w-full flex cursor-move'>
// 				<div className='text-wrap w-6/12 py-2 fontSizeClass paddingYForItems'>
// 					{hasVariant ? `${item.productName} ${item.variantName}` : item.productName}
// 				</div>
// 				<div className='w-2/12 p-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems'>
// 					₹ {item.rate}
// 				</div>
// 				<div className='w-2/12 p-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems'>
// 					{item.quantity}
// 				</div>
// 				<div className='w-2/12 py-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems'>
// 					₹ {item.quantity * item.rate}
// 				</div>
// 			</div>
// 		);
// 	} else {
// 		return (
// 			<div ref={(node) => drag(drop(node))} style={{ opacity }} className='w-full flex text-nowrap cursor-move'>
// 				<div className='w-6/12 py-2 fontSizeClass paddingYForItems'>{item.addonName}</div>
// 				<div className='w-2/12 p-2 flex justify-end items-center fontSizeClass paddingYForItems'>₹ {item.rate}</div>
// 				<div className='w-2/12 p-2 flex justify-end items-center fontSizeClass paddingYForItems'>{item.quantity}</div>
// 				<div className='w-2/12 py-2 flex justify-end items-center fontSizeClass paddingYForItems'>
// 					₹ {item.quantity * item.rate}
// 				</div>
// 			</div>
// 		);
// 	}
// };

// // Draggable Section Component
// const DraggableSection = ({ section, index, moveSection, children }) => {
// 	const [{ isDragging }, drag] = useDrag({
// 		type: 'SECTION',
// 		item: { index },
// 		collect: (monitor) => ({
// 			isDragging: monitor.isDragging(),
// 		}),
// 	});

// 	const [, drop] = useDrop({
// 		accept: 'SECTION',
// 		hover: (draggedItem) => {
// 			if (draggedItem.index !== index) {
// 				moveSection(draggedItem.index, index);
// 				draggedItem.index = index;
// 			}
// 		},
// 	});

// 	const opacity = isDragging ? 0.4 : 1;

// 	return (
// 		<div ref={(node) => drag(drop(node))} style={{ opacity }} className="cursor-move">
// 			{children}
// 		</div>
// 	);
// };

// // Main Component with DnD
// function PrintDesignDefault({ onClose, tableNo, area_id, table, billNo, previousSelectedItems, toIncludeAddonsToPrint, total, orderToKot }) {
// 	const api_base_url = process.env.REACT_APP_API_BASE_URL;
// 	// const { logginedDB, userType, handleGetCompanyDetails, companyDetails } = useContext(DBContext);
// 		const {logginedDB ,customerCode ,user ,getName, sideNavState, companyDetails, sideNavStateFunc, notification, setNotification } = useContext(DBContext);
// 	console.log( companyDetails, "print design default");
// 	const navigate = useNavigate(null);

// 	// State for draggable items and sections
// 	const [items, setItems] = useState(previousSelectedItems);
// 	const [addons, setAddons] = useState(toIncludeAddonsToPrint);
// 	const [sections, setSections] = useState([
// 		'header',
// 		'invoiceTitle',
// 		'customerInfo',
// 		'itemsTable',
// 		'totalSection'
// 	]);

// 	// Move items within the same type
// 	const moveItem = (fromIndex, toIndex, type) => {
// 		if (type === "product") {
// 			const updatedItems = [...items];
// 			const [movedItem] = updatedItems.splice(fromIndex, 1);
// 			updatedItems.splice(toIndex, 0, movedItem);
// 			setItems(updatedItems);
// 		} else {
// 			const updatedAddons = [...addons];
// 			const [movedAddon] = updatedAddons.splice(fromIndex, 1);
// 			updatedAddons.splice(toIndex, 0, movedAddon);
// 			setAddons(updatedAddons);
// 		}
// 	};

// 	// Move sections
// 	const moveSection = (fromIndex, toIndex) => {
// 		const updatedSections = [...sections];
// 		const [movedSection] = updatedSections.splice(fromIndex, 1);
// 		updatedSections.splice(toIndex, 0, movedSection);
// 		setSections(updatedSections);
// 	};

// 	// Render section based on type and order
// 	const renderSection = (section) => {
// 		switch (section) {
// 			case 'header':
// 				return (
// 					<div key="header" className='w-full h-max flex justify-center items-center'>
// 						<img
// 							src={companyDetails?.img}
// 							alt="?"
// 							className="w-full h-full object-cover"
// 						/>
// 						{/* <img className='w-[5rem] h-[5rem]' src={companyDetails.img} alt="" /> */}
// 					</div>
// 				);
// 			case 'companyInfo':
// 				return (
// 					<div key="companyInfo" className='w-full h-max flex flex-col justify-center items-center font-[600]'>
// 						<span className='fontSizeClass headWeight'>SHERDINE</span>
// 						<span className='fontSizeClass headWeight'>PERINTHALMANNA</span>
// 						<span className='fontSizeClass headWeight'>GST No M43010G195260</span>
// 					</div>
// 				);
// 			case 'invoiceTitle':
// 				return (
// 					<div key="invoiceTitle" className='w-full h-max flex gap-1 text-center justify-center items-center'>
// 						<div className="w-full h-[1px] border-t-2 hrBorder border-dashed border-[#b6b6b6] printCustomClassContainerBorderTop" />
// 						<span className='fontSizeClass highFontWeight'>INVOICE</span>
// 						<div className="w-full h-[1px] border-t-2 hrBorder border-dashed border-[#b6b6b6] printCustomClassContainerBorderTop" />
// 					</div>
// 				);
// 			case 'customerInfo':
// 				return (
// 					<div key="customerInfo" className='printCustomClassContainerInfo w-full h-max flex text-[.9rem]'>
// 						<div className='w-full flex flex-col text-left'>
// 							<span className='fontSizeClass'>Name : <span className='highFontWeight'>Gopu</span></span>
// 							<span className='fontSizeClass'>Table : <span className='highFontWeight'>#{tableNo}</span></span>
// 							<span className='fontSizeClass'>Cashier : <span className='highFontWeight'>biller</span></span>
// 						</div>
// 						<div className='w-max text-nowrap flex flex-col text-left'>
// 							<span className='fontSizeClass w-full flex gap-1'>
// 								<span className='w-full'>Invoice No : </span>
// 								<span className='w-max highFontWeight'>369</span>
// 							</span>
// 							<span className='fontSizeClass w-full flex gap-1'>
// 								<span className='w-full'>Time : </span>
// 								<span className='w-max highFontWeight'>{getCurrentTime()}</span>
// 							</span>
// 							<span className='fontSizeClass w-full flex gap-1'>
// 								<span className='w-full'>Date : </span>
// 								<span className='w-max highFontWeight'>{getCurrentDate()}</span>
// 							</span>
// 						</div>
// 					</div>
// 				);
// 			case 'itemsTable':
// 				return (
// 					<div key="itemsTable" className='w-full flex flex-col'>
// 						<div className='w-full printCustomClassContainerBorderY flex border-y-2 border-dashed border-[#b6b6b6] font-[600]'>
// 							<div className='w-6/12 py-2 fontSizeClass '>Item</div>
// 							<div className='w-2/12 p-2 flex justify-end items-center fontSizeClass '>Price</div>
// 							<div className='w-2/12 p-2 flex justify-end items-center fontSizeClass '>Qty</div>
// 							<div className='w-2/12 py-2 flex justify-end items-center fontSizeClass '>Total</div>
// 						</div>
// 						<div className='w-full flex flex-col pb-1 border-b-2 border-dashed border-[#b6b6b6] printCustomClassContainerTable'>
// 							{items.map((item, index) => (
// 								<DraggableItem
// 									key={index}
// 									item={item}
// 									index={index}
// 									moveItem={moveItem}
// 									type="product"
// 								/>
// 							))}
// 							{addons.map((addon, index) => (
// 								<DraggableItem
// 									key={`addon-${index}`}
// 									item={addon}
// 									index={index}
// 									moveItem={moveItem}
// 									type="addon"
// 								/>
// 							))}
// 						</div>
// 					</div>
// 				);
// 			case 'totalSection':
// 				return (
// 					<div key="totalSection" className='w-full h-max flex flex-col gap-3 text-nowrap border-b-2 border-dashed border-[#b6b6b6] printCustomClassContainerTable'>
// 						{/* ... your total section JSX ... */}
// 					</div>
// 				);
// 			default:
// 				return null;
// 		}
// 	};

// 	// Your existing functions (getCurrentDate, getCurrentTime, handlePrintBill, etc.)
// 	function getCurrentDate() {
// 		const today = new Date();
// 		const day = String(today.getDate()).padStart(2, '0');
// 		const month = String(today.getMonth() + 1).padStart(2, '0');
// 		const year = today.getFullYear();
// 		return `${day}/${month}/${year}`;
// 	}

// 	function getCurrentTime() {
// 		const today = new Date();
// 		const hours = String(today.getHours()).padStart(2, '0');
// 		const minutes = String(today.getMinutes()).padStart(2, '0');
// 		return `${hours}:${minutes}`;
// 	}

// 	const printRef = useRef(null);

// 	const handlePrintBill = async () => {
// 		// Your existing print logic
// 	};

// 	return (
// 		<DndProvider backend={HTML5Backend}>
// 			<div className='relative w-[30rem] printCustomClass h-full flex items-end bg-[#fff] font-nunito' ref={printRef}>
// 				{/* Your existing control buttons */}
// 				<div className='absolute top-0 right-0 transform translate-x-full pl-2 flex flex-col gap-2 printButton'>
// 					<button className='p-2 cursor-pointer flex justify-center items-center bg-[#fff]' onClick={() => onClose(false)}>
// 						<img className='w-[1.5rem]' src={close} alt="" />
// 					</button>
// 					<div className='bg-[#fff] flex justify-center items-center'>
// 						<ReactToPrint
// 							trigger={() => (
// 								<button className="p-2 cursor-pointer hover:bg-[#cddcfc]">
// 									<img className='w-[2rem]' src={print} alt="" />
// 								</button>
// 							)}
// 							content={() => printRef.current}
// 							onAfterPrint={handlePrintBill}
// 						/>
// 					</div>
// 				</div>

// 				{/* Draggable Sections */}
// 				<div className='printCustomClassContainer w-full h-full flex flex-col p-10 gap-3 overflow-x-hidden overflow-y-auto customScroll'>
// 					{sections.map((section, index) => (
// 						<DraggableSection
// 							key={section}
// 							section={section}
// 							index={index}
// 							moveSection={moveSection}
// 						>
// 							{renderSection(section)}
// 						</DraggableSection>
// 					))}
// 				</div>
// 			</div>
// 		</DndProvider>
// 	);
// }

// // export default PrintBillDesigner;
// // function PrintDesignDefault() {
// //   const [scanResult, setScanResult] = useState("");
// //   const [food, setFood] = useState(null);
// //   const [error, setError] = useState("");

// //     return (
// //         <div>
// //             <h1>PrintDesignDefault.jsx</h1>
// //             <Draggable>
// //                 <div>I can now be moved around!</div>
// //             </Draggable>
// //         </div>
// //     )
// // }

// export default PrintDesignDefault

// import React, { useState, useRef, useEffect, useContext } from 'react';
// import { DndProvider, useDrag, useDrop } from 'react-dnd';
// import { HTML5Backend } from 'react-dnd-html5-backend';
// import ReactToPrint from "react-to-print";
// import { ToastContainer, toast } from 'react-toastify';
// import { useLocation, useNavigate } from 'react-router-dom';
// import io from 'socket.io-client';
// import { DBContext } from '../DBContext'
// import { DineContext } from '../DineContext'
// import print from '../assets/assets/images/print.png'
// import close from '../assets/assets/images/close.png'
// import Remove from "../images/icons/remove.png"

// // Draggable Item Component
// const DraggableItem = ({ item, index, moveItem, type = "product" }) => {
// 	const [{ isDragging }, drag] = useDrag({
// 		type: 'PRINT_ITEM',
// 		item: { index, type },
// 		collect: (monitor) => ({
// 			isDragging: monitor.isDragging(),
// 		}),
// 	});

// 	const [, drop] = useDrop({
// 		accept: 'PRINT_ITEM',
// 		hover: (draggedItem) => {
// 			if (draggedItem.index !== index) {
// 				moveItem(draggedItem.index, index, draggedItem.type);
// 				draggedItem.index = index;
// 			}
// 		},
// 	});

// 	const opacity = isDragging ? 0.4 : 1;

// 	if (type === "product") {
// 		const hasVariant = item.variantName || null;
// 		return (
// 			<div ref={(node) => drag(drop(node))} style={{ opacity }} className='w-full flex cursor-move'>
// 				<div className='text-wrap w-6/12 py-2 fontSizeClass paddingYForItems'>
// 					{hasVariant ? `${item.productName} ${item.variantName}` : item.productName}
// 				</div>
// 				<div className='w-2/12 p-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems'>
// 					₹ {item.rate}
// 				</div>
// 				<div className='w-2/12 p-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems'>
// 					{item.quantity}
// 				</div>
// 				<div className='w-2/12 py-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems'>
// 					₹ {item.quantity * item.rate}
// 				</div>
// 			</div>
// 		);
// 	} else {
// 		return (
// 			<div ref={(node) => drag(drop(node))} style={{ opacity }} className='w-full flex text-nowrap cursor-move'>
// 				<div className='w-6/12 py-2 fontSizeClass paddingYForItems'>{item.addonName}</div>
// 				<div className='w-2/12 p-2 flex justify-end items-center fontSizeClass paddingYForItems'>₹ {item.rate}</div>
// 				<div className='w-2/12 p-2 flex justify-end items-center fontSizeClass paddingYForItems'>{item.quantity}</div>
// 				<div className='w-2/12 py-2 flex justify-end items-center fontSizeClass paddingYForItems'>
// 					₹ {item.quantity * item.rate}
// 				</div>
// 			</div>
// 		);
// 	}
// };

// // Draggable Section Component
// const DraggableSection = ({ section, index, moveSection, children }) => {
// 	const [{ isDragging }, drag] = useDrag({
// 		type: 'SECTION',
// 		item: { index },
// 		collect: (monitor) => ({
// 			isDragging: monitor.isDragging(),
// 		}),
// 	});

// 	const [, drop] = useDrop({
// 		accept: 'SECTION',
// 		hover: (draggedItem) => {
// 			if (draggedItem.index !== index) {
// 				moveSection(draggedItem.index, index);
// 				draggedItem.index = index;
// 			}
// 		},
// 	});

// 	const opacity = isDragging ? 0.4 : 1;

// 	return (
// 		<div ref={(node) => drag(drop(node))} style={{ opacity }} className="cursor-move">
// 			{children}
// 		</div>
// 	);
// };

// // Main Component with DnD
// function PrintDesignDefault({ onClose, tableNo, area_id, table, billNo, previousSelectedItems, toIncludeAddonsToPrint, total, orderToKot }) {
// 	const api_base_url = process.env.REACT_APP_API_BASE_URL;
// 	const { logginedDB, customerCode, user, getName, sideNavState, companyDetails, sideNavStateFunc, notification, setNotification } = useContext(DBContext);
// 	console.log(companyDetails, "print design default");
// 	const navigate = useNavigate(null);

// 	// State for draggable items and sections
// 	const [items, setItems] = useState(previousSelectedItems);
// 	const [addons, setAddons] = useState(toIncludeAddonsToPrint);
// 	const [sections, setSections] = useState([
// 		'header',
// 		'invoiceTitle',
// 		'customerInfo',
// 		'itemsTable',
// 		'totalSection'
// 	]);

// 	// Move items within the same type
// 	const moveItem = (fromIndex, toIndex, type) => {
// 		if (type === "product") {
// 			const updatedItems = [...items];
// 			const [movedItem] = updatedItems.splice(fromIndex, 1);
// 			updatedItems.splice(toIndex, 0, movedItem);
// 			setItems(updatedItems);
// 		} else {
// 			const updatedAddons = [...addons];
// 			const [movedAddon] = updatedAddons.splice(fromIndex, 1);
// 			updatedAddons.splice(toIndex, 0, movedAddon);
// 			setAddons(updatedAddons);
// 		}
// 	};

// 	// Move sections
// 	const moveSection = (fromIndex, toIndex) => {
// 		const updatedSections = [...sections];
// 		const [movedSection] = updatedSections.splice(fromIndex, 1);
// 		updatedSections.splice(toIndex, 0, movedSection);
// 		setSections(updatedSections);
// 	};

// 	// Render section based on type and order
// 	const renderSection = (section) => {
// 		switch (section) {
// 			case 'header':
// 				return (
// 					<div key="header" className='w-full h-max flex justify-center items-center'>
// 						<img
// 							// src={companyDetails?.img}
// 							alt="?"
// 							className="w-full h-full object-cover"
// 						/>
// 					</div>
// 				);
// 			case 'companyInfo':
// 				return (
// 					<div key="companyInfo" className='w-full h-max flex flex-col justify-center items-center font-[600]'>
// 						<span className='fontSizeClass headWeight'>SHERDINE</span>
// 						<span className='fontSizeClass headWeight'>PERINTHALMANNA</span>
// 						<span className='fontSizeClass headWeight'>GST No M43010G195260</span>
// 					</div>
// 				);
// 			case 'invoiceTitle':
// 				return (
// 					<div key="invoiceTitle" className='w-full h-max flex gap-1 text-center justify-center items-center'>
// 						<div className="w-full h-[1px] border-t-2 hrBorder border-dashed border-[#b6b6b6] printCustomClassContainerBorderTop" />
// 						<span className='fontSizeClass highFontWeight'>INVOICE</span>
// 						<div className="w-full h-[1px] border-t-2 hrBorder border-dashed border-[#b6b6b6] printCustomClassContainerBorderTop" />
// 					</div>
// 				);
// 			case 'customerInfo':
// 				return (
// 					<div key="customerInfo" className='printCustomClassContainerInfo w-full h-max flex text-[.9rem]'>
// 						<div className='w-full flex flex-col text-left'>
// 							<span className='fontSizeClass'>Name : <span className='highFontWeight'>Gopu</span></span>
// 							<span className='fontSizeClass'>Table : <span className='highFontWeight'>#{tableNo}</span></span>
// 							<span className='fontSizeClass'>Cashier : <span className='highFontWeight'>biller</span></span>
// 						</div>
// 						<div className='w-max text-nowrap flex flex-col text-left'>
// 							<span className='fontSizeClass w-full flex gap-1'>
// 								<span className='w-full'>Invoice No : </span>
// 								<span className='w-max highFontWeight'>369</span>
// 							</span>
// 							<span className='fontSizeClass w-full flex gap-1'>
// 								<span className='w-full'>Time : </span>
// 								<span className='w-max highFontWeight'>{getCurrentTime()}</span>
// 							</span>
// 							<span className='fontSizeClass w-full flex gap-1'>
// 								<span className='w-full'>Date : </span>
// 								<span className='w-max highFontWeight'>{getCurrentDate()}</span>
// 							</span>
// 						</div>
// 					</div>
// 				);
// 			case 'itemsTable':
// 				return (
// 					<div key="itemsTable" className='w-full flex flex-col'>
// 						<div className='w-full printCustomClassContainerBorderY flex border-y-2 border-dashed border-[#b6b6b6] font-[600]'>
// 							<div className='w-6/12 py-2 fontSizeClass '>Item</div>
// 							<div className='w-2/12 p-2 flex justify-end items-center fontSizeClass '>Price</div>
// 							<div className='w-2/12 p-2 flex justify-end items-center fontSizeClass '>Qty</div>
// 							<div className='w-2/12 py-2 flex justify-end items-center fontSizeClass '>Total</div>
// 						</div>
// 						<div className='w-full flex flex-col pb-1 border-b-2 border-dashed border-[#b6b6b6] printCustomClassContainerTable'>
// 							{items.map((item, index) => (
// 								<DraggableItem
// 									key={index}
// 									item={item}
// 									index={index}
// 									moveItem={moveItem}
// 									type="product"
// 								/>
// 							))}
// 							{addons.map((addon, index) => (
// 								<DraggableItem
// 									key={`addon-${index}`}
// 									item={addon}
// 									index={index}
// 									moveItem={moveItem}
// 									type="addon"
// 								/>
// 							))}
// 						</div>
// 					</div>
// 				);
// 			case 'totalSection':
// 				return (
// 					<div key="totalSection" className='w-full h-max flex flex-col gap-3 text-nowrap border-b-2 border-dashed border-[#b6b6b6] printCustomClassContainerTable'>
// 						{/* ... your total section JSX ... */}
// 					</div>
// 				);
// 			default:
// 				return null;
// 		}
// 	};

// 	// Your existing functions (getCurrentDate, getCurrentTime, handlePrintBill, etc.)
// 	function getCurrentDate() {
// 		const today = new Date();
// 		const day = String(today.getDate()).padStart(2, '0');
// 		const month = String(today.getMonth() + 1).padStart(2, '0');
// 		const year = today.getFullYear();
// 		return `${day}/${month}/${year}`;
// 	}

// 	function getCurrentTime() {
// 		const today = new Date();
// 		const hours = String(today.getHours()).padStart(2, '0');
// 		const minutes = String(today.getMinutes()).padStart(2, '0');
// 		return `${hours}:${minutes}`;
// 	}

// 	const printRef = useRef(null);

// 	const handlePrintBill = async () => {
// 		// Your existing print logic
// 	};

// 	return (
// 		<DndProvider backend={HTML5Backend}>
// 			<div className='relative w-[30rem] printCustomClass h-full flex items-end bg-[#fff] font-nunito' ref={printRef}>
// 				{/* Your existing control buttons */}
// 				<div className='absolute top-0 right-0 transform translate-x-full pl-2 flex flex-col gap-2 printButton'>
// 					<button className='p-2 cursor-pointer flex justify-center items-center bg-[#fff]' onClick={() => onClose(false)}>
// 						<img className='w-[1.5rem]' src={close} alt="" />
// 					</button>
// 					<div className='bg-[#fff] flex justify-center items-center'>
// 						<ReactToPrint
// 							trigger={() => (
// 								<button className="p-2 cursor-pointer hover:bg-[#cddcfc]">
// 									<img className='w-[2rem]' src={print} alt="" />
// 								</button>
// 							)}
// 							content={() => printRef.current}
// 							onAfterPrint={handlePrintBill}
// 						/>
// 					</div>
// 				</div>

// 				{/* Draggable Sections */}
// 				<div className='printCustomClassContainer w-full h-full flex flex-col p-10 gap-3 overflow-x-hidden overflow-y-auto customScroll'>
// 					{sections.map((section, index) => (
// 						<DraggableSection
// 							key={section}
// 							section={section}
// 							index={index}
// 							moveSection={moveSection}
// 						>
// 							{renderSection(section)}
// 						</DraggableSection>
// 					))}
// 				</div>
// 			</div>
// 		</DndProvider>
// 	);
// }

// export default PrintDesignDefault

import React, { useState, useRef, useEffect, useContext } from 'react';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import ReactToPrint from "react-to-print";
import { ToastContainer, toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import io from 'socket.io-client';
import { DBContext } from '../DBContext'
import { DineContext } from '../DineContext'
import print from '../assets/assets/images/print.png'
import close from '../assets/assets/images/close.png'
import Remove from "../images/icons/remove.png"
import SideNav from '../SideNav'
import TopRootDiv from '../TopRootDiv';
import SherDineNav from '../SherDineNav';

// Draggable Item Component
const DraggableItem = ({ item, index, moveItem, type = "product" }) => {
	const [{ isDragging }, drag] = useDrag({
		type: 'PRINT_ITEM',
	 
		item: { index, type },
		collect: (monitor) => ({
			isDragging: monitor.isDragging(),
		}),
	});

	const [, drop] = useDrop({
		accept: 'PRINT_ITEM',
		hover: (draggedItem) => {
			if (draggedItem.index !== index) {
				moveItem(draggedItem.index, index, draggedItem.type);
				draggedItem.index = index;
			}
		},
	});

	const opacity = isDragging ? 0.4 : 1;

	if (type === "product") {
		const hasVariant = item.variantName || null;
		return (
			<div ref={(node) => drag(drop(node))} style={{ opacity }} className='w-full flex cursor-move'>
				<div className='text-wrap w-6/12 py-2 fontSizeClass paddingYForItems'>
					{hasVariant ? `${item.productName} ${item.variantName}` : item.productName}
				</div>
				<div className='w-2/12 p-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems'>
					₹ {item.rate}
				</div>
				<div className='w-2/12 p-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems'>
					{item.quantity}
				</div>
				<div className='w-2/12 py-2 flex justify-end items-center text-nowrap fontSizeClass paddingYForItems'>
					₹ {item.quantity * item.rate}
				</div>
			</div>
		);
	} else {
		return (
			<div ref={(node) => drag(drop(node))} style={{ opacity }} className='w-full flex text-nowrap cursor-move'>
				<div className='w-6/12 py-2 fontSizeClass paddingYForItems'>{item.addonName}</div>
				<div className='w-2/12 p-2 flex justify-end items-center fontSizeClass paddingYForItems'>₹ {item.rate}</div>
				<div className='w-2/12 p-2 flex justify-end items-center fontSizeClass paddingYForItems'>{item.quantity}</div>
				<div className='w-2/12 py-2 flex justify-end items-center fontSizeClass paddingYForItems'>
					₹ {item.quantity * item.rate}
				</div>
			</div>
		);
	}
};

// Draggable Section Component
const DraggableSection = ({ section, index, moveSection, children }) => {
	const [{ isDragging }, drag] = useDrag({
		type: 'SECTION',
		item: { index },
		collect: (monitor) => ({
			isDragging: monitor.isDragging(),
		}),
	});

	const [, drop] = useDrop({
		accept: 'SECTION',
		hover: (draggedItem) => {
			if (draggedItem.index !== index) {
				moveSection(draggedItem.index, index);
				draggedItem.index = index;
			}
		},
	});

	const opacity = isDragging ? 0.4 : 1;

	return (
		<div ref={(node) => drag(drop(node))} style={{ opacity }} className="cursor-move">
			{children}
		</div>
	);
};

// Main Component with DnD
// function PrintDesignDefault({ onClose, tableNo, area_id, table, billNo, previousSelectedItems, toIncludeAddonsToPrint, total, orderToKot }) {
// 	const api_base_url = process.env.REACT_APP_API_BASE_URL;
// 	const { logginedDB, customerCode, user, getName, sideNavState, companyDetails, sideNavStateFunc, notification, setNotification } = useContext(DBContext);
// 	console.log(companyDetails, "print design default");
// 	const navigate = useNavigate(null);

function PrintDesignDefault({ onClose, tableNo, area_id, table, billNo, previousSelectedItems, toIncludeAddonsToPrint, total, orderToKot }) {
	const api_base_url = process.env.REACT_APP_API_BASE_URL;
	const context = useContext(DBContext);
	const { logginedDB, customerCode, user, getName, sideNavState, companyDetails, sideNavStateFunc, notification, setNotification } = context;
	
	console.log("Full DBContext:", context);
	console.log("CompanyDetails:", companyDetails);
	
	const navigate = useNavigate(null);


	// State for draggable items and sections
	const [items, setItems] = useState(previousSelectedItems);
	const [addons, setAddons] = useState(toIncludeAddonsToPrint);
	const [sections, setSections] = useState([
		'header',
		'invoiceTitle',
		'customerInfo',
		'itemsTable',
		'totalSection'
	]);

	// Move items within the same type
	const moveItem = (fromIndex, toIndex, type) => {
		if (type === "product") {
			const updatedItems = [...items];
			const [movedItem] = updatedItems.splice(fromIndex, 1);
			updatedItems.splice(toIndex, 0, movedItem);
			setItems(updatedItems);
		} else {
			const updatedAddons = [...addons];
			const [movedAddon] = updatedAddons.splice(fromIndex, 1);
			updatedAddons.splice(toIndex, 0, movedAddon);
			setAddons(updatedAddons);
		}
	};

	// Move sections
	const moveSection = (fromIndex, toIndex) => {
		const updatedSections = [...sections];
		const [movedSection] = updatedSections.splice(fromIndex, 1);
		updatedSections.splice(toIndex, 0, movedSection);
		setSections(updatedSections);
	};

	// Render section based on type and order
	const renderSection = (section) => {
		switch (section) {
			case 'header':
				return (
					<div key="header" className='w-full h-max flex justify-center items-center'>
						<img
							src={companyDetails?.img}
							alt="?"
							className="w-full h-full object-cover"
						/>
					</div>
				);
			case 'companyInfo':
				return (
					<div key="companyInfo" className='w-full h-max flex flex-col justify-center items-center font-[600]'>
						<span className='fontSizeClass headWeight'>SHERDINE</span>
						<span className='fontSizeClass headWeight'>PERINTHALMANNA</span>
						<span className='fontSizeClass headWeight'>GST No M43010G195260</span>
					</div>
				);
			case 'invoiceTitle':
				return (
					<div key="invoiceTitle" className='w-full h-max flex gap-1 text-center justify-center items-center'>
						<div className="w-full h-[1px] border-t-2 hrBorder border-dashed border-[#b6b6b6] printCustomClassContainerBorderTop" />
						<span className='fontSizeClass highFontWeight'>INVOICE</span>
						<div className="w-full h-[1px] border-t-2 hrBorder border-dashed border-[#b6b6b6] printCustomClassContainerBorderTop" />
					</div>
				);
			case 'customerInfo':
				return (
					<div key="customerInfo" className='printCustomClassContainerInfo w-full h-max flex text-[.9rem]'>
						<div className='w-full flex flex-col text-left'>
							<span className='fontSizeClass'>Name : <span className='highFontWeight'>Gopu</span></span>
							<span className='fontSizeClass'>Table : <span className='highFontWeight'>#{tableNo}</span></span>
							<span className='fontSizeClass'>Cashier : <span className='highFontWeight'>biller</span></span>
						</div>
						<div className='w-max text-nowrap flex flex-col text-left'>
							<span className='fontSizeClass w-full flex gap-1'>
								<span className='w-full'>Invoice No : </span>
								<span className='w-max highFontWeight'>369</span>
							</span>
							<span className='fontSizeClass w-full flex gap-1'>
								<span className='w-full'>Time : </span>
								<span className='w-max highFontWeight'>{getCurrentTime()}</span>
							</span>
							<span className='fontSizeClass w-full flex gap-1'>
								<span className='w-full'>Date : </span>
								<span className='w-max highFontWeight'>{getCurrentDate()}</span>
							</span>
						</div>
					</div>
				);
			case 'itemsTable':
				return (
					<div key="itemsTable" className='w-full flex flex-col'>
						<div className='w-full printCustomClassContainerBorderY flex border-y-2 border-dashed border-[#b6b6b6] font-[600]'>
							<div className='w-6/12 py-2 fontSizeClass '>Item</div>
							<div className='w-2/12 p-2 flex justify-end items-center fontSizeClass '>Price</div>
							<div className='w-2/12 p-2 flex justify-end items-center fontSizeClass '>Qty</div>
							<div className='w-2/12 py-2 flex justify-end items-center fontSizeClass '>Total</div>
						</div>
						<div className='w-full flex flex-col pb-1 border-b-2 border-dashed border-[#b6b6b6] printCustomClassContainerTable'>
							{items.map((item, index) => (
								<DraggableItem
									key={index}
									item={item}
									index={index}
									moveItem={moveItem}
									type="product"
								/>
							))}
							{addons.map((addon, index) => (
								<DraggableItem
									key={`addon-${index}`}
									item={addon}
									index={index}
									moveItem={moveItem}
									type="addon"
								/>
							))}
						</div>
					</div>
				);
			case 'totalSection':
				return (
					<div key="totalSection" className='w-full h-max flex flex-col gap-3 text-nowrap border-b-2 border-dashed border-[#b6b6b6] printCustomClassContainerTable'>
						{/* ... your total section JSX ... */}
					</div>
				);
			default:
				return null;
		}
	};

	// Your existing functions (getCurrentDate, getCurrentTime, handlePrintBill, etc.)
	function getCurrentDate() {
		const today = new Date();
		const day = String(today.getDate()).padStart(2, '0');
		const month = String(today.getMonth() + 1).padStart(2, '0');
		const year = today.getFullYear();
		return `${day}/${month}/${year}`;
	}

	function getCurrentTime() {
		const today = new Date();
		const hours = String(today.getHours()).padStart(2, '0');
		const minutes = String(today.getMinutes()).padStart(2, '0');
		return `${hours}:${minutes}`;
	}

	const printRef = useRef(null);

	const handlePrintBill = async () => {
		// Your existing print logic
	};

	return (
		<div className='w-screen h-screen flex overflow-hidden'>
			<div className='w-full h-full overflow-hidden hidden sm:flex sm:flex-col'>
				<SherDineNav />
				<div className='w-full bg-[#f5f5f5] flex-grow flex gap-3 overflow-hidden'>
					<div className='w-max h-full z-[9999]'>
						<SideNav focus={'Print Design'} />
					</div>
					<div className='w-full h-full flex flex-col pr-3 pl-0 pb-3 pt-0 gap-3 overflow-hidden'>
						<div className="pr-3 h-max w-full bg-[#fff] borderBottom">
							<TopRootDiv image={'Print Design'} root={['Print Design']} />
						</div>
						<div className='relative w-full h-full flex flex-col gap-3 p-2 font-nunito overflow-hidden'>
							<DndProvider backend={HTML5Backend}>
								<div className='relative w-full h-full flex items-end bg-[#fff] font-nunito' ref={printRef}>
									{/* Your existing control buttons */}
									<div className='absolute top-0 right-0 transform translate-x-full pl-2 flex flex-col gap-2 printButton'>
										<button className='p-2 cursor-pointer flex justify-center items-center bg-[#fff]' onClick={() => onClose(false)}>
											<img className='w-[1.5rem]' src={close} alt="" />
										</button>
										<div className='bg-[#fff] flex justify-center items-center'>
											<ReactToPrint
												trigger={() => (
													<button className="p-2 cursor-pointer hover:bg-[#cddcfc]">
														<img className='w-[2rem]' src={print} alt="" />
													</button>
												)}
												content={() => printRef.current}
												onAfterPrint={handlePrintBill}
											/>
										</div>
									</div>

									{/* Draggable Sections */}
									<div className='printCustomClassContainer w-full h-full flex flex-col p-10 gap-3 overflow-x-hidden overflow-y-auto customScroll'>
										{sections.map((section, index) => (
											<DraggableSection
												key={section}
												section={section}
												index={index}
												moveSection={moveSection}
											>
												{renderSection(section)}
											</DraggableSection>
										))}
									</div>
								</div>
							</DndProvider>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default PrintDesignDefault
